/*

ID: "1"
CODE: "moscow"
NAME: "Москва"
KLADR: "7700000000000"
REGION_CODE: "RU-MOW"
CURRENT: false

*/

export const onlineCityCode = "7102000200000";

const cities = Object.values(window.city).map(city => {
  return {
    id: city.ID,
    code: city.CODE,
    name: city.NAME,
    kladr: city.KLADR,
    selected: city.CURRENT,
    regionCode: city.REGION_CODE,
  };
});

// Add online city
cities.push({
	id: "0",
  code: "online",
  name: "Другие города",
  kladr: onlineCityCode,
  selected: false,
  regionCode: "ON-LINE",
})

export default cities;
